exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host .content {\n  position: relative;\n  padding-top: 1rem;\n  padding-right: 2rem;\n  padding-bottom: 1rem;\n  padding-left: 2rem; }\n  :host .content-wrapper {\n    width: 100%; }\n\n:host .centerized {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  z-index: 1; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/ui-form/components/form-wizard-pane/form-wizard-pane.component.scss
// module id = ../../../../../src/app/modules/ui-form/components/form-wizard-pane/form-wizard-pane.component.scss
// module chunks = main